// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__mWH2U","logo":"styles_logo__VCBRa","contentWrapper":"styles_contentWrapper__4Gj2B"};